import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { languages } from "../constants/languages";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    width: "95%",
    maxWidth: 400,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 90
  }),
  textField: {
    margin: theme.spacing(1),
    width: 200
  },
  button: {
    margin: theme.spacing(1)
  },
  headline: {
    margin: theme.spacing(1)
  },
  link: {
    display: "block",
    margin: theme.spacing(1)
  }
});

const ForgotPassword = props => {
  const { classes } = props;
  return (
    <div>
      <Paper className={classes.root} elevation={4}>
        <Typography variant="h5" component="h3" className={classes.headline}>
          {languages.login.forgotPassword}
        </Typography>
        <Typography className={classes.headline}>
          {languages.login.forgotPasswordDescription}
        </Typography>
        <TextField
          type="email"
          label="E-mail"
          value={props.email}
          onChange={props.handleEmailChange}
          className={classes.textField}
        />
        <div className={classes.textField} style={{ color: "red" }}>
          {props.errorMessage}
        </div>
        {props.sent && (
          <div style={{ color: "green" }} className={classes.textField}>
            {languages.login.resetEmailSent}
          </div>
        )}
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={props.handleSubmit}
          disabled={props.buttonDisabled}
        >
          {languages.login.send}
        </Button>
        <Link to="/" className={classes.link}>
          {languages.login.back}
        </Link>
      </Paper>
    </div>
  );
};

ForgotPassword.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ForgotPassword);
